import { Outlet } from "react-router-dom";

export function Sourcing() {
  return <Outlet />;
}
